import { config } from "JS/Config";
import {
    Content,
    PlaylistAudio,
    PlaylistResponse,
    ReceivedGift,
} from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export class PlaylistService extends BaseService {
    getPlaylists = () =>
        this.ngCall<PlaylistResponse[]>(
            "get",
            appConstants.ngEndpoints.getPlaylists(config.user.memberId),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    createPlaylist = (title: string) =>
        this.createPlaylistWithContents(title, null);

    createPlaylistWithContents = (
        title: string,
        content: (Content | ReceivedGift)[],
    ) =>
        this.ngCall<number>(
            "post",
            appConstants.ngEndpoints.createPlaylist(config.user.memberId),
            {
                playlistName: title,
                contents: content?.map((c) => ({
                    nid: c.nid,
                    skuId: c.sku_id,
                })),
            },
        );

    deletePlaylist = (id: number) =>
        this.ngCall(
            "delete",
            appConstants.ngEndpoints.deletePlaylist(config.user.memberId, id),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    renamePlaylist = (id: number, newName: string) =>
        this.ngCall<void>(
            "patch",
            appConstants.ngEndpoints.renamePlaylist(config.user.memberId, id),
            {
                playlistName: newName,
            },
        );

    sortPlaylist(ids: string[]) {
        return this.ngCall(
            "post",
            appConstants.ngEndpoints.sortPlaylist(config.user.memberId),
            { playlistIds: ids },
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );
    }

    getPlaylistAudios = (id: string) =>
        this.ngCall<PlaylistAudio[]>(
            "get",
            appConstants.ngEndpoints.playlistContent(config.user.memberId, id),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    removeAudioFromPlaylist = (id: string, audioNid: string) =>
        this.ngCall<void>(
            "delete",
            appConstants.ngEndpoints.removeFromPlaylist(
                config.user.memberId,
                id,
                audioNid,
            ),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    addAudioToPlaylist = (id: string, audioNid: string, contentType: string) =>
        this.ngCall<void>(
            "put",
            appConstants.ngEndpoints.addToPlaylist(
                config.user.memberId,
                id,
                audioNid,
            ),
            null,
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
                params: {
                    contentType,
                },
            },
        );

    sortAudiosInPlaylist = (id: string, nids: string[]) =>
        this.ngCall<void>(
            "patch",
            appConstants.ngEndpoints.sortAudiosInPlaylist(
                config.user.memberId,
                id,
            ),
            {
                nids,
            },
        );
}
